import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { SystemSection } from './components/SystemSection';
import { BonusOutcomeSection } from './components/BonusOutcomeSection';
import { OfferSection } from './components/OfferSection';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: PixelFunction;
    _fbq?: PixelFunction;
  }
}
export function App() {
  useEffect(() => {
    try {
      if (window.fbq) return;
      const pixel = ((...args: unknown[]) => {
        if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue.push(args);
      }) as PixelFunction;
      pixel.queue = [];
      pixel.push = pixel;
      pixel.loaded = true;
      pixel.version = '2.0';
      window.fbq = pixel;
      window._fbq = pixel;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript?.parentNode) firstScript.parentNode.insertBefore(script, firstScript);else document.head.appendChild(script);
      pixel('init', '943022892065433');
      pixel('track', 'PageView');
    } catch {/* Pixel loading must never interrupt a preview or page render. */}
  }, []);
  return <><noscript data-id="element-0" data-mp="3dlntsez5axxr"><img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=943022892065433&ev=PageView&noscript=1" alt="" data-id="element-1" data-mp="3dmfprqwnmxok" /></noscript><div className="min-h-screen w-full overflow-x-hidden bg-canvas" data-id="element-2" data-mp="sudl6ejybx89"><main data-id="element-3" data-mp="ssss6tdacmci"><Hero data-id="element-4" data-mp="swqd9kjfbnz1" /><PainSection data-id="element-5" data-mp="swgkxqawp4q6" /><SystemSection data-id="element-6" data-mp="36huv2f1ajz4" /><BonusOutcomeSection data-id="element-7" data-mp="35ypel6klo1z" /><OfferSection data-id="element-8" data-mp="35gm54lhq9kk" /><Guarantee data-id="element-9" data-mp="34x1hg4gh72u" /><Testimonials data-id="element-10" data-mp="34nbvtnbp1xo" /><FAQ data-id="element-11" data-mp="38b5essrpoce" /><FinalCTA data-id="element-12" data-mp="38b6kw4i7udz" /></main><Footer data-id="element-13" data-mp="3ud1f186rfma3" /><PurchaseToast data-id="element-14" data-mp="3udax89lkcp58" /></div></>;
}